interface TextSectionProps {
  text?: string;
}

const TextSection = ({ text }: TextSectionProps) => {
  return (
    <div className="d-flex flex-column gap-8">
      <span className="f-12 line-height-18 f-400 f-grey">{text}</span>
    </div>
  );
};

export default TextSection;
